import {Component, OnInit, ViewEncapsulation} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';
import {AuthenticationService} from '../../../services/apiServices/security/authentication.service';
import {CreateDepositService} from '../../../services/apiServices/business/create-deposit.service';
import {UpdateSearchFiltersService} from '../../../services/crossComponent/update-search-filters.service';
import {SearchService} from '../../../services/apiServices/business/search.service';
import {Unsubscribable} from "../../mixin/unsubscribable.component";


/**
 * top navigation bar
 */
@Component({
  selector: 'app-side-bar',
  templateUrl: 'side-bar.component.html',
  styleUrls: ['side-bar.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class SideBarComponent extends Unsubscribable(class {}) implements OnInit {
  depositDir: string;
  public panelOpened: boolean;
  public progressInterval = null;
  public progressPersisted = 0;
  public savingTrial = 1;
  public depositPersistedSerialLot: number = null;

  constructor(private translate: TranslateService, private authService: AuthenticationService,
              private createDepositService: CreateDepositService,
              private updateSearchFiltersService: UpdateSearchFiltersService, private searchService: SearchService) {
    super();
    this.panelOpened = false;
  }

  /**
   * Retrieve message of the day
   */
  public ngOnInit(): void {
    this.panelOpened = false;
    this.createDepositService.runningExpressDeposit.subscribe( depositDir => {
      this.depositDir = depositDir;
      if (depositDir) {
        this.checkProgress();
        setTimeout(() => {
          this.showPanel();
        }, 500);
      }
      else {
        this.hidePanel();
        clearInterval(this.progressInterval);
      }
    });
  }

  togglePanel(): void {
    if (this.panelOpened) {
      this.hidePanel();
    }
    else {
      this.showPanel();
    }
  }
  public showPanel(): void {
    setTimeout(() => {
      this.panelOpened = true;
    }, 300);
  }

  public hidePanel(): void {
    setTimeout(() => {
      this.panelOpened = false;
    }, 300);
  }
  checkProgress() {
    this.progressInterval = setInterval(() => {
      // const dataToSend = {depositDir: this.depositDir};
      const dataToSend = new FormData();
      dataToSend.append('depositDir', this.depositDir);
      this.createDepositService.checkExpressDepositProgress(dataToSend)
        .pipe(this.takeUntilDestroyed())
        .subscribe( response => {
        if (response.trial) {
          this.savingTrial = response.trial;
        }
        if (response.progress) {
          this.progressPersisted = response.progress;
        }
        if (response.serialLotDepot) {
          this.depositPersistedSerialLot = response.serialLotDepot;
        }
        if (response.status && (response.status === 'FINISHED' || response.status === 'FAILED' || response.status === 'NOT_FOUND')) {
          clearInterval(this.progressInterval);
          this.showDepositInSearchForm();
        }
        if (!response) {
          clearInterval(this.progressInterval);
        }
      });
    }, 1000);
  }
  showDepositInSearchForm() {
    this.depositDir = null;
    this.updateSearchFiltersService.depositNumber.next('' + this.depositPersistedSerialLot);
    setTimeout(() => {
      this.searchService.searchRequested();
    }, 500);
  }
}
